import script from "./MsComboboxItemSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./MsComboboxItemSingle.vue?vue&type=script&setup=true&lang=js"

import "./MsComboboxItemSingle.vue?vue&type=style&index=0&id=c7a4bbc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7a4bbc0"]])

export default __exports__